import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    remove() {
        this.element.remove();

        // Update all swipers on the page, once the element is removed
        for (const swiperContainer of document.querySelectorAll('.swiper, .swiper-container')) {
            const swiper = swiperContainer.swiper;

            if (swiper) {
                swiper.update();
            }
        }
    }
}
